import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
// Import the Quill styles
// import axios from "axios";
import axiosInstance from "../../config/axios";
import { toast } from "react-toastify";

const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["bold", "italic", "underline", "strike"],
    ["link", "image", "video"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    ["clean"],
  ],
  clipboard: {
    matchVisual: false,
  },
};

const formats = [
  "header",
  "font",
  "list",
  "bullet",
  "align",
  "bold",
  "italic",
  "underline",
  "strike",
  "link",
  "image",
  "video",
  "color",
  "background",
  "script",
  "blockquote",
  "code-block",
];

const TermsAndCondition = () => {
  const [terms, setTerms] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get("api/admin/term-condition-api/")
      .then((response) => {
        setTerms(response?.data?.data?.contain || "");
      })
      .catch((err) => {
        setError("Failed to load terms and conditions.");
        setIsLoading(false);
      });
    setIsLoading(false);
  }, []);

  const handleChange = (value) => {
    setTerms(value);
  };

  const handleSubmit = () => {
    setIsLoading(true);
    axiosInstance
      .post("api/admin/term-condition-api/", { contain: terms })
      .then((response) => {
        toast.success(response?.data?.msg);
      })
      .catch((err) => {
        setError("Failed to update terms and conditions.");
      });
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-lg font-semibold">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-lg text-red-500">
        {error}
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6  max-h-screen overflow-y-auto  pt-5 pb-10">
      <div className="max-w-[70%] mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">
          Terms and Conditions
        </h1>

        <div className="mb-6">
          <ReactQuill
            value={terms}
            onChange={handleChange}
            modules={modules}
            formats={formats}
          />
        </div>

        <div className="text-center">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-200"
          >
            Update Terms and Conditions
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
